import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  primary: { fontSize: '14px', lineHeight: '20px' },
  root: { paddingTop: '4px', paddingBottom: '4px' },
  subheader: {
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 'bold',
    paddingLeft: '8px'
  }
}));

const SpecifiersList = (props) => {
  const { schema, specifiers } = props;
  const classes = useStyles();

  return (
    <List
      component="nav"
      aria-label="secondary mailbox folder"
      subheader={
        <ListSubheader disableSticky={true} classes={{ root: classes.subheader }} component="div" id="nested-list-subheader">
          {schema.label}
        </ListSubheader>
      }
    >
      {
        specifiers[schema.name]
          .map(q => (
            <ListItem
              button
              classes={{ root: classes.root }}
              selected={props.values.specifiers?.[schema.name] === q}
              key={q}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: 'specifiers', value: {
                      ...props.values.specifiers,
                      [schema.name]: props.values.specifiers?.[schema.name] !== q
                        ? q
                        : ''
                    }
                  }
                });
                props.submitForm();
              }}
            >
              <ListItemText classes={{ primary: classes.primary }} primary={q} />
            </ListItem>
          ))
      }
    </List>
  );
};

export default SpecifiersList;